export default __webpack_public_path__ + "static/media/student.e97e6925.svg";